var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"id":"buttom-row-tab"}},[_c('v-col',{staticClass:"d-flex align-center",attrs:{"cols":"auto","md":"auto","sm":"auto","id":"buttom-col-tab"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }